import React, {useMemo, useRef, useState} from "react";
import {useAuth} from "../../../providers/AuthProvider";
import dateformat from "dateformat";
import ReactDOM from "react-dom";
import Form from "../../../components/form/Form";


let SupplierFormItemContext = React.createContext(null);

const SupplierFormItemProvider = ({children, deleteOnly, formStyle = {borderTop: `5px solid white`,}, className = '',
                                      model, isEditing, canEdit = true, isUpdating, onEditing = () => true, onSave = () => true,
                                      itemIndex, itemPropName, displayName, onChange, deleteEnabled = false,
                                      ...props}) => {


    const {auth} = useAuth();

    const supplierOrg = auth?.supplierOrg();
    const [itemModel, setItemModel] = useState(() => ({...(model || {})}));

    const ItemType = 'Item'
    const FormClass = 'talent-role-form add-talent-form ' + className


    const formRef = useRef(null);

    const creatingNewItem = () => {
        return !TB.keys(model).length || !TB.isDefined(model.id)
    }


    const hasChanged = () => {
        if (!model) return false;
        // console.log('hasChanged', itemModel, model)
        return false;// !TB.isEqual(itemModel, model)
    }
    const monthOptions = useMemo(() => [{
        label: 'Month',
        value: '',
        disabled: false
    }].concat([
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
    ].map( (month, index) => {
            return {
                label: String(month),
                value: index + 1
            };
        }
    )), [])

    const yearOptions = useMemo(() => {
        return [{
            label: 'Year',
            value: '',
            disabled: false
        }].concat(TB.rangeRight(1900, (new Date()).getFullYear() + 1)
            .map( year => {
                    return {
                        label: String(year),
                        value: year
                    };
                }
            )
        );
    }, [])

    const setDateFromInputs = (model, dateField) => {
        let newDate = model[dateField];
        let year = model[dateField + '_year'];
        let month = model[dateField + '_month'];

        if (!TB.isNaN(year) && !TB.isNaN(month)) {
            newDate = new Date(year, month - 1, 1);
        } else if (!TB.isNaN(year)) {
            newDate = new Date(year, 1, 1);
        } else if (TB.isDefined(model[dateField])) {
            newDate = undefined;
        }

        let format = 'mm-yyyy';

        if (newDate && dateformat(newDate, format) !== dateformat(model[dateField], format)) {
            return {[dateField]: newDate};
        }else if (newDate !== model[dateField]) {
            return {[dateField]: newDate};
        }
        return {};
    }

    const validateDateBeforeToday = (field, display = null) => {
        if (!display) display = TB.upperFirst(TB.lowerCase(field));

        let errors = {};
        if (itemModel[field]) {
            errors = {[field]: null};
            // Check earned date after today
            if (itemModel[field] > (new Date())) {
                errors[field] = display + " must be before today"
            }
        }
        return errors;
    }

    const validateDateAfterDate = (field, before_field,  error = null) => {
        if (!error) error = TB.trans('talent.school_form.validations.before_start_date');

        let errors = {};
        if(itemModel[field]) {
            errors = {[field]: null};
            // Check end date before start
            if (itemModel[field] < itemModel[before_field]) {
                errors[field] = error;
            }
        }

        return errors;
    }

    const onSubmit = () => {
        return onSave(itemModel)
    }

    const invalidFields = () => {
        if (!formRef.current){
            return false
        }
        return formRef.current.forceValidate();
    }

    const refreshForm = async() => {

        // await setItemModel({...model})
        console.log("refresh",model)
        await formRef.current.updateInputsWithValue(model);

        await formRef.current.forceReset(model);
        await setItemModel({...model})
        return onEditing(false);
    }
    const validateAndSave = () => {
        let elem = invalidFields();

        if(elem) {
            const node = ReactDOM.findDOMNode(elem);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }else {
            return onSubmit()
        }
    }

    let value = {
        profileItem: itemModel,
        profileIndex: itemIndex,
        itemIndex,
        itemPropName,
        isEditing,
        onEditing,
        onModelChange: (itemProps) => {
            if (!isEditing) return;
            let updates = {...itemModel}
            for (let [key, value] of Object.entries(itemProps)) {
                updates = TB.set(updates, key, value)
            }

            if (onChange) {
                updates = onChange(updates)
            }
            setItemModel(updates)
        },
        refresh: () => {

        },
        deleteItem: () => {

        },
        monthOptions,
        yearOptions,
        setDateFromInputs,
        validateDateBeforeToday,
        validateDateAfterDate,
    }

    const renderFormFooter = () => {
        return (
            <div className="role-form-footer">

                {isEditing && (
                    <div className={"edit-btn-row"}>
                        <button
                            className="btn btn-primary mr-3"
                            disabled={isUpdating}
                            onClick={() => validateAndSave()}
                            type="button">
                            {TB.trans('talent.profile_item_form.save_btn')}
                        </button>
                        <button
                            className="btn btn-outline-dark"
                            disabled={isUpdating}
                            type="button" formNoValidate
                            onClick={async () => {

                                if (creatingNewItem()) {
                                    await onSave()
                                    return onEditing(false);
                                } else {
                                    return refreshForm()

                                    let title = TB.trans('talent.profile_item_form.alerts.cancel_header');
                                    let message = TB.trans('talent.profile_item_form.alerts.cancel_body');

                                    let shouldCancel = await TB.alert(
                                        'error',
                                        String(title),
                                        String(message),
                                        [
                                            {title: String(TB.trans('talent.profile_item_form.alerts.btn_ok_txt'))},
                                            {title: String(TB.trans('talent.profile_item_form.alerts.btn_cancel_txt'))},
                                        ]
                                    );

                                    if (shouldCancel) {
                                        await formRef.current.forceReset(model);
                                        await formRef.current.updateInputsWithValue(model);
                                        return onEditing(false);
                                    }
                                }
                            }}
                        >
                            {TB.trans('talent.profile_item_form.cancel_btn')}
                        </button>
                    </div>
                )}


                {(!isEditing && !deleteOnly) ? (
                    <React.Fragment>

                        <button
                            className="btn btn-link"
                            disabled={isUpdating || (!isEditing && !canEdit)}
                            type="button" onClick={() => onEditing(true)}>
                            {TB.trans('talent.profile_item_form.edit_btn')} {displayName}
                        </button>
                        {deleteEnabled && (
                            <button className="btn btn-link ml-0"
                                    disabled={isUpdating || (!isEditing && !canEdit)}
                                    type="button"
                                    onClick={async () => {
                                        let shouldDelete = await TB.alert(
                                            'error',
                                            `Delete ${displayName}?`,
                                            'Are you sure you want to delete this? Any unsaved changes will be removed.', [
                                                {title: 'Yes, delete'},
                                                {title: 'Cancel'},
                                            ]
                                        )

                                        if (shouldDelete) {
                                            await onSave()
                                            return onEditing(false);
                                        }
                                    }}>
                                {TB.trans('talent.profile_item_form.delete_btn')} {displayName}
                            </button>
                        )}
                    </React.Fragment>
                ) : ((!creatingNewItem() || deleteOnly) && (
                        <button className="btn btn-link"
                                disabled={isUpdating || (!isEditing && !canEdit)}
                                type="button"
                                onClick={async () => {
                                    let shouldDelete = await TB.alert(
                                        'error',
                                        `Delete ${displayName}?`,
                                        'Are you sure you want to delete this? Any unsaved changes will be removed.', [
                                            {title: 'Yes, delete'},
                                            {title: 'Cancel'},
                                        ]
                                    )

                                    if (shouldDelete) {
                                        await onSave()
                                        return onEditing(false);
                                    }
                                }}>
                            {TB.trans('talent.profile_item_form.delete_btn')} {displayName}
                        </button>
                    )
                )}

            </div>
        )
    }
    return (
        <SupplierFormItemContext.Provider value={value}>
            <div className={TB.mapClass(FormClass, {
                // 'no-edit': !isEditing,
                'pointer-events-none opacity-80': (!isEditing && !canEdit) || isUpdating,
                'active-edit': isEditing,
                'inactive-edit': !isEditing
            })} style={formStyle}>

                {(!isEditing && props.preview && TB.isDefined(itemModel?.id)) ? (
                    <div className="wripple-form">
                        <div className="form-container">
                            <div className="form-title-section">
                                <div className="step-title-content">
                                    <div>
                                        <h3 className="form-title">
                                            {displayName} #{itemIndex + 1}
                                        </h3>
                                    </div>
                                </div>
                            </div>


                            {props.preview}
                            {renderFormFooter()}
                        </div>
                    </div>
                ) : (
                    <Form
                        ref={formRef}
                        key={itemPropName + itemIndex + isEditing}
                        title={<div className="form-title-section">
                            <div className="step-title-content">
                                <div>
                                    <h3 className="form-title">
                                        {displayName} #{itemIndex + 1}
                                    </h3>
                                </div>
                            </div>
                        </div>}
                        subtitle={null}
                        showRequired
                        submitButton={false}
                        onChange={(itemProps) => {
                            if (!isEditing) return;
                            let updates = {...itemModel}
                            for (let [key, value] of Object.entries(itemProps)) {
                                updates = TB.set(updates, key, value)
                            }

                            if (onChange) {
                                updates = onChange(updates)
                            }
                            setItemModel(updates)
                        }}
                        model={itemModel}
                        fields={[]}
                        isDisabled={isUpdating || !isEditing}>

                        {children}

                        {renderFormFooter()}
                    </Form>
                )}

            </div>
        </SupplierFormItemContext.Provider>
    );
}

const useSupplierFormItem = () => {
    return React.useContext(SupplierFormItemContext);
}
export default SupplierFormItemProvider;
export {
    useSupplierFormItem,
    SupplierFormItemContext
}